<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="setAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.props.$invalid " :vm-active="isModalActionPropVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-model="props" label='Folio de la Orden de Compra')
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalQuotationsActionProp',
  props: {
    title: {
      type: String,
      default: 'Orden de compra del cliente'
    },
    id: {
      type: Number,
      default: 0
    },
    props: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    sold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'isModalActionPropVisible'
    ]),
    order_customer () {
      return `?order_customer=${this.props}`
    }
  },
  validations: {
    props: {
      required
    }
  },
  methods: {
    ...mapActions([
      'actionQuotation',
      'setModalActionPropVisible'
    ]),
    async setAction () {
      await this.actionQuotation({ id: this.id, props: this.order_customer, action: this.action }).then(() => {
        this.actionQuotation({ id: this.id, action: 'sold' })
      })
    },
    close () {
      this.setModalActionPropVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
